module.exports = __webpack_public_path__ + "img/icon8.540bdc02.svg";